import React from 'react';
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import helper from '../../Utils/helpers'
import './SearchResults.css'
import Card, {DefaultCard} from "../Card/Card";
import useModal from "../../Hooks/useModal";
import Modals from "../../Constants/modals";
import Tooltip, { TooltipContent, TooltipTrigger } from "../Overlays/Tooltip";
import SkynetIcon from "../Fundamentals/SkynetIcon";

function UserIcon({ customer }) {
    const { t } = useTranslation();

    let icon = null;
    let title = null;

    if (customer.isConsultant) {
        icon = "vismaicon-user-connection";
        title = "vonaccountscontainer.consultant";
    }

    if (!icon)
        return null;

    return (<Tooltip>
        <TooltipTrigger>
            <SkynetIcon icon={`${icon} vismaicon-sm mr-8`} />
        </TooltipTrigger>
        <TooltipContent>
            <div>{t(title)}</div>
        </TooltipContent>
    </Tooltip>)
}

const SearchResults= ({state, dropdownlists, clickEvent, user}) => {
    const {t} = useTranslation();
    const { openModal } = useModal();
    
    if (!state.searchResult && !state.isSearching)
        return null
    
    const headerContent = () => {
        return <Card.Header.Title>
            {state.searchResult ? <>
                {state.searchResult?.length} {t('searchresult.resultsfor')}
                <strong>"{state.searchInput}"</strong></> : <>{t('searchresult.searching')}</>}
            </Card.Header.Title>
    }

    return <DefaultCard headerContent={headerContent()} isLoading={state.isSearching}>
        {state.searchResult?.length === 0 ?
            <div className="row justify-content-center">
                <h3><a className="text-nowrap" onClick={() => openModal(Modals.CreateCustomer)}>{"Create new customer?"}</a></h3>
            </div>
            :
            <table className="table table-stripe table-hover">
                <thead>
                <tr>
                    <th width="200" className="text-right">{t('searchresult.organizationnumber')}</th>
                    <th width="200" className="text-right">{t('searchresult.customernumber')}</th>
                    <th>{t('searchresult.name')}</th>
                    <th>{t('searchresult.customergroup')}</th>
                    <th>{t('searchresult.customertype')}</th>
                    <th>{t('searchresult.status')}</th>
                    <th>{t('searchresult.phonenumber')}</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                {
                    state.searchResult?.map(customer =>
                        <tr key={customer.pathId + customer.organizationNumber}
                            onClick={() => clickEvent(customer.pathId)} className="cursorpointer">
                            <td className="text-right">{customer.organizationNumber}</td>
                            <td className="text-right">{customer.customerNumber}</td>
                            <td className="text-left">{customer.name} </td>
                            <td className="text-left">{helper.getDropdownItemName(dropdownlists?.CustomerGroup, customer.group)}</td>
                            <td className="text-left">{customer.targetGroup ? helper.getDropdownItemName(dropdownlists?.TargetGroup, customer.targetGroup) : helper.getDropdownItemName(dropdownlists?.CustomerType, customer.type)}</td>
                            <td className="text-left">{helper.getDropdownItemName(dropdownlists?.CustomerStatus, customer.status)}</td>
                            <td className="text-left">{customer.phoneNumber}</td>
                            <td><UserIcon customer={customer}/></td>
                        </tr>
                    )
                }
                </tbody>
            </table>
        }
    </DefaultCard>
}

export default SearchResults;